import { Component, ViewChild, isDevMode } from '@angular/core';
import { MenuController, Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TranslateService } from '@ngx-translate/core';
import { GlobalvarsProvider } from '../providers/globalvars/globalvars';
import { AudioProvider } from '../providers/audio/audio';
import { ApiProvider } from '../providers/api/api';
import { SyncProvider } from '../providers/sync/sync';
import { CronProvider } from "../providers/cron/cron";
import { Storage } from '@ionic/storage';
//import { BackgroundMode } from "@ionic-native/background-mode";
import { LoggerProvider, LogLevel } from "../providers/logger/logger";


interface MenuItem {
  title: string,
  page: any,
  link: string,
  icon: string,
  visible: boolean
}


@Component({
  templateUrl: 'app.html'/*,
  providers: [GlobalvarsProvider, AudioProvider, ApiProvider, SyncProvider]*/
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  private log_level: LogLevel = LogLevel.Info;
  private log_label_main: string = 'App';

  rootPage: string = 'SplashPage';
  pages: Array<MenuItem>;
  menuIcons: boolean = false;

  showRemoteAppMenuItem: boolean = false;
  showWebAppMenuItem: boolean = false;
  showSFAppMenuItem: boolean = false;

  channelsPageTitle: string;
  syncPageTitle: string;
  playersPageTitle: string;
  streamsPageTitle: string;
  profilePageTitle: string;
  contactPageTitle: string;
  legalPageTitle: string;
  privacyPageTitle: string;

  // 2019
  private backgroundMode: any = null;

  // 2019-02-25
  private initialHref: string;

  constructor(
    public platform: Platform,
    public translateService: TranslateService,
    public menu: MenuController,
    public storage: Storage,
    public globalvarsProvider: GlobalvarsProvider,
    public audioProvider: AudioProvider,
    public apiProvider: ApiProvider,
    public syncProvider: SyncProvider,
    public cronProvider: CronProvider,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    //private backgroundMode: BackgroundMode,
    private logger: LoggerProvider
  ) {
    let me = this;
    let log_label: string = me.log_label_main + '::constructor';
    me.logger.setLogLevel(me, me.log_level);

    me.logger.info(me, log_label);

    me.initialHref = '/'; // window.location.href;
    me.logger.info(me, log_label + ':initialHref', {initialHref: me.initialHref});

    // env
    me.showEnv();

    // language
    me.initLanguage();

    // begin
    me.platform.ready().then(() => {
      me.logger.info(me, log_label + ':platform:ready');

      me.clearStorage().then(() => {
        // app
        me.initializeApp();

        // providers
        me.initProviders();

        // events
        me.initEvents();

        // 2019-01-27
        const currentPath = me.platform.url().split('/');
        const currentPage = currentPath[currentPath.length - 1];
        me.logger.warn(me, log_label, {currentPath: currentPath, currentPage: currentPage});

        switch (currentPage) {
          case "splash":
          case "login":
            break;

          // 2019-02-25
/*
          case "channels":
            me.logger.warn(me, log_label, {setRoot: "SplashPage"});
            me.nav.setRoot("SplashPage");
            break;
*/

          default:
            me.logger.warn(me, log_label, {setRoot: "LoginPage"});
            me.nav.setRoot("LoginPage");
            break;
        }
      });
    });
  }

  showEnv(): void {
    let me = this;
    let log_label: string = me.log_label_main + '::showEnv';

    me.logger.warn(me, log_label);

    // env
    me.logger.info(me, log_label + ':env', {devMode: JSON.stringify(isDevMode())});
    
    // platform
    me.logger.debug(me, log_label + ':version', me.globalvarsProvider.version);
    me.logger.debug(me, log_label + ':platforms', me.platform.platforms());

    me.logger.debug(me, log_label + ':is platform', {
      ios: me.platform.is('ios'),
      android: me.platform.is('android'),
      windows: me.platform.is('windows'),
      combined_and: me.platform.is('ios') && !me.platform.is('windows'),
      combined_or: me.platform.is('ios') || !me.platform.is('windows')
    });
  }
  
  private initLanguage(): void {
    let me = this;
    let log_label: string = me.log_label_main + '::initLanguage';

    me.logger.warn(me, log_label);

    /* https://javebratt.com/angular-translate-ionic/ */
    me.translateService.setDefaultLang('en');

    const browserLang = me.translateService.getBrowserLang();
    me.logger.warn(me, log_label + ':browserLang:detect', {browserLang: browserLang});

    if (browserLang) {
      switch(browserLang) {
        case 'de':
        case 'en':
        case 'fr':
          me.logger.warn(me, log_label + ':browserLang:match', {browserLang: browserLang});

          me.globalvarsProvider.lang = browserLang;

          break;
      }
    }

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    me.logger.warn(me, log_label + ':browserLang:set', {lang: me.globalvarsProvider.lang});
    me.translateService.use(me.globalvarsProvider.lang);
  }

  private initEvents(): void {
    let me = this;
    let log_label: string = me.log_label_main + '::initEvents';

    me.logger.warn(me, log_label);

    me.globalvarsProvider.appTypeEvent.subscribe(event => {
      me.logger.info(me, log_label + ':appTypeEvent', {event: event});

      me.globalvarsProvider.appType = event;

      switch (event) {
        case 'remoteapp':
          me.showRemoteAppMenuItem = true;
          me.showWebAppMenuItem = false;
          me.showSFAppMenuItem = false;
          me.prepareMenuPages();
          break;

        case 'webapp':
          me.showRemoteAppMenuItem = false;
          me.showWebAppMenuItem = true;
          me.showSFAppMenuItem = false;
          me.prepareMenuPages();
          break;

        case 'sfapp':
          me.showRemoteAppMenuItem = false;
          me.showWebAppMenuItem = false;
          me.showSFAppMenuItem = true;
          me.prepareMenuPages();
          me.setKeepData(event);
          break;
      }

      me.apiProvider.navTypeEvent.next("ready");
    });

    me.apiProvider.navTypeEvent.subscribe(event => {
      me.logger.info(me, log_label + ':navTypeEvent', {event: event});

      switch (event) {
        case 'logout':
          me.doLogout();
          break;

        case 'restart':
          me.doRestart();
          break;

        default:
          break;
      }
    });
  }

  setKeepData(type: string): void {
    let me = this;
    let log_label: string = me.log_label_main + '::setKeepData';

    me.logger.warn(me, log_label);

    me.storage.set('keep_data', true).then(() => {
      me.logger.info(me, log_label + ':storeSet:keep_data:done', {result: true});

      if (type) {
        me.storage.set('app_type', type).then(() => {
          me.logger.info(me, log_label + ':storeSet:app_type:done', {result: type});

        }, error => {
          me.logger.error(me, log_label + ':storeSet:app_type:error', {error: error});
        });
      }

    }, error => {
      me.logger.error(me, log_label + ':storeSet:keep_data:error', {error: error});
    });
  }

  private clearStorage(): Promise<any> {
    let me = this;
    let log_label: string = me.log_label_main + '::clearStorage';

    me.logger.warn(me, log_label);

    return new Promise((resolve, reject) => {
      let storageLabel: string = 'keep_data';

      me.storage.get(storageLabel).then((keep_data) => {
        me.logger.info(me, log_label + ':storage:get', {storageLabel: storageLabel, keep_data: keep_data});

        if (!keep_data) {
          me.storage.clear().then(() => {
            me.logger.info(me, log_label + ':storage:clear');

            me.logger.info(me, log_label + ':resolve');
            resolve();

          }, error => {
            me.logger.error(me, log_label + ':storage:clear:error', {error: error});
            reject(error);
          });

        } else {
          //me.reinitiateApp();
          me.logger.info(me, log_label + ':resolve');
          resolve();
        }

      }, error => {
        me.logger.error(me, log_label + ':storage:get:error', {storageLabel: storageLabel, error: error});
      });
    });
  }

  reinitiateApp() {
    let me = this;
    let log_label: string = me.log_label_main + '::reinitiateApp';

    me.logger.warn(me, log_label);

    me.storage.get('app_type').then((app_type) => {
      me.logger.info(me, log_label + ':storeGet:app_type:done', {result: app_type});

      switch(app_type) {
        case 'sfapp':
          me.globalvarsProvider.secondPage = 'ChannelsPage';
      }

      me.globalvarsProvider.appTypeEvent.next(app_type);

    }, error => {
      me.logger.error(me, log_label + ':storeGet:app_type:error', {error: error});
    });
  }

  prepareMenuPages() {
    let me = this;
    let log_label: string = me.log_label_main + '::prepareMenuPages';

    me.logger.warn(me, log_label);
    
    me.translateService.get([
      'channels_title',
      'sync_title',
      'players_title',
      'streams_title',
      'profile_title',
      'contact_title',
      'legal_title',
      'privacy_title'
    ]).subscribe(values => {
      me.channelsPageTitle = values.channels_title;
      me.syncPageTitle = values.sync_title;
      me.playersPageTitle = values.players_title;
      me.streamsPageTitle = values.streams_title;
      me.profilePageTitle = values.profile_title;
      me.contactPageTitle = values.contact_title;
      me.legalPageTitle = values.legal_title;
      me.privacyPageTitle = values.privacy_title;

      me.setMenuPages();
    });

    me.menuIcons = me.globalvarsProvider.menuIcons;
  }

  setMenuPages() {
    let me = this;
    let log_label: string = me.log_label_main + '::setMenuPages';

    me.logger.warn(me, log_label);
    
    // set our app's pages
    me.pages = [
      { title: me.playersPageTitle,     page: 'PlayersPage',  link: null,         icon: 'musical-notes',      visible: me.showRemoteAppMenuItem },
      { title: me.streamsPageTitle,     page: 'StreamsPage',  link: null,         icon: 'musical-notes',      visible: me.showWebAppMenuItem },
      { title: me.channelsPageTitle,    page: 'ChannelsPage', link: null,         icon: 'musical-notes',      visible: me.showSFAppMenuItem },
      { title: me.syncPageTitle,        page: 'SyncPage',     link: null,         icon: 'cloud',              visible: me.showSFAppMenuItem },
      { title: me.profilePageTitle,     page: 'ProfilePage',  link: null,         icon: 'person',             visible: false },
      { title: me.contactPageTitle,     page: 'ContactPage',  link: null,         icon: 'call',               visible: true },
      { title: me.legalPageTitle,       page: null,           link: 'imprint',    icon: 'school',             visible: true },
      { title: me.privacyPageTitle,     page: null,           link: 'privacy',    icon: 'information-circle', visible: true }
    ];

    me.logger.info(me, log_label, {pages: me.pages});
  }

  initializeApp() {
    let me = this;
    let log_label: string = me.log_label_main + '::initializeApp';

    me.logger.warn(me, log_label);

/*
    me.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
*/

      // layout
      me.statusBar.styleDefault();
      if (me.platform.is('android')) {
        // https://stackoverflow.com/questions/47470486/ionic3-android-status-bar-no-icon-shown
        me.statusBar.styleBlackOpaque();
      }
      me.statusBar.overlaysWebView(false);  // 2018-11-20, iOS
      me.splashScreen.hide();

      // background mode
      if (me.backgroundMode) {
        me.logger.info(me, log_label + ':backgroundMode:enabling');

        me.backgroundMode.on('*').subscribe(event => {
          me.logger.info(me, log_label + ':backgroundMode:event', {event: event});

        }, error => {
          me.logger.error(me, log_label + ':backgroundMode:error', {error: error});
        });

        me.backgroundMode.setDefaults({silent: true});
        me.backgroundMode.enable();

        me.logger.info(me, log_label + ':backgroundMode:status', {
          isEnabled: me.backgroundMode.isEnabled(),
          isActive: me.backgroundMode.isActive()
        });
      }

/*
    });
*/
  }

  private initProviders(): void {
    let me = this;
    let log_label: string = me.log_label_main + '::initProviders';

    me.logger.warn(me, log_label);

    // providers
    let promises: Array<any> = [];

    promises.push(me.globalvarsProvider.appReady());
    promises.push(me.apiProvider.appReady());
    promises.push(me.audioProvider.appReady());
    promises.push(me.cronProvider.appReady());
    promises.push(me.syncProvider.appReady());

    Promise.all(promises).then(() => {
      me.logger.info(me, log_label + ':appReady:all');

      me.initAfterProviders();

    }, error => {
      me.logger.error(me, log_label + ':appReady:error', {error: error});

      me.initAfterProviders();
    });
  }

  private initAfterProviders(): void {
    let me = this;
    let log_label: string = me.log_label_main + '::initAfterProviders';

    me.logger.warn(me, log_label);

    me.globalvarsProvider.afterAppReady();
    me.apiProvider.afterAppReady();
    //me.audioProvider.afterAppReady();
    //me.syncProvider.afterAppReady();

    // 2018-11-27
    me.reinitiateApp();
  }

  openPage(menuEntry: any): void {
    let me = this;
    let log_label: string = me.log_label_main + '::openPage';

    me.logger.warn(me, log_label);
    me.logger.info(me, log_label, {menuEntry: menuEntry});

    // close the menu when clicking a link from the menu
    me.menu.close().then(() => {}, () => {});

    if (menuEntry.page) {
      // navigate to the new page if it is not the current page
      me.nav.setRoot(menuEntry.page).then(() => {}, () => {});

    } else if (menuEntry.link) {
      // open link
      me.globalvarsProvider.openExternalLink(menuEntry.link);
    }
  }

  doLogout() {
    let me = this;
    let log_label: string = me.log_label_main + '::doLogout';

    me.logger.warn(me, log_label);

    me.menu.close().then(() => {}, () => {});

    // 2019-02-25
    me.doCleanUp();

    // api call
    me.apiProvider.callDoLogout().then(data => {
      me.logger.info(me, log_label + ':callDoLogout:done', {data: data});

      me.removeKeepData();

    }, error => {
      me.logger.error(me, log_label + ':callDoLogout:error', {error: error});

      me.removeKeepData();
    });
  }

  doRestart(): void {
    let me = this;
    let log_label: string = me.log_label_main + '::doRestart';

    me.logger.warn(me, log_label, {location: window.location, initialHref: me.initialHref});

    me.splashScreen.show();

    me.doCleanUp();

    // Reload original app url (ie your index.html file)
    //window.location.href = me.initialHref;
    //window.location.reload();
    //window.location.replace(me.initialHref);
    me.nav.setRoot('SplashPage').then(() => {
      me.logger.warn(me, log_label + ':reload');

      window.location.reload();

    }, () => {
      me.logger.warn(me, log_label + ':error');
    });
  }

  private doCleanUp(): void {
    let me = this;
    let log_label: string = me.log_label_main + '::doCleanUp';

    me.logger.warn(me, log_label);

    me.apiProvider.stopKeepAlive();

    me.audioProvider.audio.pause();

    me.syncProvider.doPause();

    // 2019-02-12
    me.syncProvider.stopAutoSyncs();
    // 2019-03-23
    //me.syncProvider.stopAutoSyncTimeout();
    // 2019-03-16
    me.syncProvider.resetSyncTimes();
    // 2019-03-23
    me.syncProvider.stopCron();

    // 2019-02-12
    me.syncProvider.resetMusicControls(true);
    //me.syncProvider.resetSyncVars();

    // 2019-01-27
    me.globalvarsProvider.logConfig = false;

    // 2019-02-25
    me.globalvarsProvider.httpdStop();

    // 2019-01-08, resettheme for mobile apps only
    me.logger.debug(me, log_label, {
      android: me.platform.is('android'),
      ios: me.platform.is('ios'),
      core: me.platform.is('core')
    });

    if (
      (
        me.platform.is('android')
        ||
        me.platform.is('ios')
      )
      &&
      !me.platform.is('core')
    ) {
      // 2018-11-15
      me.globalvarsProvider.resetTheme();
    }
  }

  private removeKeepData(): void {
    let me = this;
    let log_label: string = me.log_label_main + '::removeKeepData';

    me.logger.warn(me, log_label);

    me.storage.remove('keep_data').then(() => {
      me.logger.info(me, log_label + ':storeRemove:keep_data:done');

      me.processLogout();

    }, error => {
      me.logger.error(me, log_label + ':storeRemove:keep_data:error', {error: error});

      me.processLogout();
    });
  }

  private processLogout() {
    let me = this;
    let log_label: string = me.log_label_main + '::processLogout';

    me.logger.warn(me, log_label);

    me.clearStorage();

    me.nav.setRoot('LoginPage').then(() => {}, () => {});
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts